import { currentUserVar } from "_graphql/cache/auth";

export const processUrlData = (data: Record<string, any>) => {
    const currentUser = currentUserVar();
    return btoa(
        JSON.stringify({
            ...data,
            companyName:
                currentUser?.employee?.broker_config?.broker_company_name || "",
            brokerConfigId:
                currentUser?.employee?.broker_config?.broker_configuration_id,
            ...currentUser?.employee?.broker_config?.broker_address,
        }),
    );
};
